import { styled } from "theme/default/styled";

export const SPopUpContainerContent = styled.div`
  position: relative;
  z-index: 2;
`;
